import React from "react";

export const airdropContent = {
  create_airdrop: {
    title: "Create New Airdrop",
    content: (
      <>
        <h3>Create an Airdrop</h3>
        <p>
          <strong>Disclaimer:</strong> Once you have committed tokens to the
          airdrop, it cannot be cancelled or reconfigured to reduce the amount.
          Ensure you have correctly allocated the tokens.
        </p>

        <h4>Step 1: Token Selection</h4>
        <p>
          1. Go to the <strong>Create Airdrop</strong> page. Paste your{" "}
          <strong>Token Address</strong>.
        </p>
        <img
          src="/docs/airdrop/1.png"
          alt="Enter Token Address"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          2. Verify your token details (Name, Symbol, Decimals) are correct,
          then click <strong>Next</strong>.
        </p>
        <img
          src="/docs/airdrop/2.png"
          alt="Verify Token"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 2: Airdrop Information</h4>
        <p>
          3. Input required details: <strong>Airdrop Title</strong>,{" "}
          <strong>Logo URL</strong> (must end in .png/.jpg), and{" "}
          <strong>Website</strong>. Click <strong>Create New Airdrop</strong>.
        </p>
        <img
          src="/docs/airdrop/4.png"
          alt="Airdrop Info"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />
        <img
          src="/docs/airdrop/5.png"
          alt="Airdrop Info"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>4. Confirm the creation transaction in your wallet.</p>
        <img
          src="/docs/airdrop/4.png"
          alt="Confirm Creation"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 3: Allocations</h4>
        <p>
          5. You will be redirected to the dashboard. Click{" "}
          <strong>Set Allocations</strong> to add recipients.
        </p>
        <p>
          6. Enter addresses and amounts (e.g., <code>0xAbs...123, 1000</code>).
          One entry per line.
        </p>
        <img
          src="/docs/airdrop/7.png"
          alt="Input Allocations"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          7. Add the Wallet Address, Enter the Amount and Click{" "}
          <strong>Generate Allocations</strong> and confirm the transaction.
        </p>
        <img
          src="/docs/airdrop/8.png"
          alt="Confirm Allocations"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <h4>Step 4: Submit the Airdrop</h4>
        <p>
          8. When ready, click <strong>Start Airdrop</strong>.
        </p>
        <img
          src="/docs/airdrop/13.png"
          alt="Start Airdrop"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          9. Choose to start "Now" or at a specific time. Click{" "}
          <strong>Approve</strong>.
        </p>
        <img
          src="/docs/airdrop/14.png"
          alt="Approve Start"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />
        <img
          src="/docs/airdrop/17.png"
          alt="Approve Start"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          10. After approval, click <strong>Confirm</strong> (Start) to finalize
          the process.
        </p>
        <img
          src="/docs/airdrop/19.png"
          alt="Confirm Start"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />
      </>
    ),
  },
  claim_airdrop: {
    title: "Claim Airdrop",
    content: (
      <>
        <h3>How to Claim Airdrop</h3>
        <p>
          1. Navigate to <strong>My Airdrops</strong>. You will see a list of
          airdrops you are participating in.
        </p>
        <img
          src="/docs/airdrop/15.png"
          alt="My Airdrops"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          2. Click <strong>View Airdrop</strong> to see details.
        </p>
        <img
          src="/docs/airdrop/16.png"
          alt="View Airdrop"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>
          3. Check your <strong>Claimable Tokens</strong>. Click{" "}
          <strong>Claim</strong>.
        </p>
        <img
          src="/docs/airdrop/17.png"
          alt="Click Claim"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>4. Confirm the transaction in your wallet.</p>
        <img
          src="/docs/airdrop/18.png"
          alt="Confirm Claim"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />

        <p>5. Successfully claimed! Your tokens will appear in your wallet.</p>
        <img
          src="/docs/airdrop/19.png"
          alt="Claim Success"
          style={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: "8px",
            margin: "10px 0",
          }}
        />
      </>
    ),
  },
};
